import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2942c3ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__progress-tile-bar" }
const _hoisted_2 = {
  key: 0,
  class: "boxes"
}
const _hoisted_3 = ["title"]


export default /*#__PURE__*/_defineComponent({
  __name: 'progress-tile-bar',
  props: {
    progress: {
      type: Object,
      default: null,
    },
    displayAbsoluteValues: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props) {


  const props = __props;

  const rawTotal = (boxes: any) => {
    let total = 0;
    if (boxes) {
      for (const box of boxes) {
        total += box.total;
      }
    }
    return total;
  };
  // An enabled bar with no data yet has every total = 0. Render it as a single
  // full "pending" (last) segment so the "0" is visible instead of collapsing.
  const allZero = (boxes: any) => Array.isArray(boxes) && boxes.length > 0 && rawTotal(boxes) === 0;

  const flexValue = (box: any, boxes: any, index: any) => {
    if (allZero(boxes)) {
      return index === boxes.length - 1 ? 1 : 0;
    }
    return Math.round((box.total / getTotal(boxes)) * 100) / 100;
  };
  const showBoxValue = (box: any, boxes: any, index: any) => {
    if (allZero(boxes)) {
      return index === boxes.length - 1;
    }
    return box.total / getTotal(boxes) > 0.1;
  }
  const boxTitle = (box: any, boxes: any) => {
    return `${box.label}: ${boxDisplayedValue(box, boxes)}`;
  };
  const boxDisplayedValue = (box: any, boxes: any) => {
    if (props.displayAbsoluteValues) {
      return box.total;
    }
    return Math.round((box.total * 100) / getTotal(boxes)) + "%";
  };
  const getTotal = (boxes: any) => {
    let total = 0;
    if (boxes) {
      for (const box of boxes) {
        total += box.total;
      }
    }

    if (total === 0) {
      // mitigate division by zero
      return 1;
    }
    return total;
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.progress && __props.progress.boxes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.progress.boxes, (box, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["box", {inverted: box.inverted}]),
              title: boxTitle(box, __props.progress.boxes),
              style: _normalizeStyle({'background-color': box.color, flex: flexValue(box, __props.progress.boxes, index)})
            }, [
              (showBoxValue(box, __props.progress.boxes, index))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(boxDisplayedValue(box, __props.progress.boxes)), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ], 14, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})